import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import LeadSection from "@/components/sections/LeadSection";
import ServiceArea from "@/components/sections/ServiceArea";
import EmergencySection from "@/components/sections/EmergencySection";
import { IMAGES } from "@/data/content";

export default function Contact() {
  return (
    <>
      <Seo title="Contact & Request Service | Genuine Forge — Chicago HVAC" description="Request HVAC service, an installation quote, or a commercial project review. Serving Chicago and the surrounding ~20-mile radius." />
      <PageHero eyebrow="Contact" title="Request Service" lede="Residential or commercial — tell us what your system is doing and attach photos. We'll respond with clear scope and honest options." image={IMAGES.diagnostics} />
      <LeadSection sourcePage="contact" />
      <ServiceArea />
      <EmergencySection />
    </>
  );
}
